module.exports = __webpack_public_path__ + "static/media/facebook.fcc9d4fd.svg";